import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, UserRound } from "lucide-react";
import { useAuth } from "../hooks/useAuth";
import { Button, Card, PageHeader } from "../components/ui";
import { ChangePasswordCard } from "../components/ChangePasswordCard";

const ROLE_LABEL: Record<string, string> = {
  SUPER_ADMIN: "Super Admin Platform",
  TENANT_ADMIN: "Admin Lokasi",
  THERAPIST: "Terapis",
  PATIENT: "Pasien",
};

/** Halaman profil generik (admin/terapis/super admin): data akun, ganti kata sandi & keluar. */
export function ProfilePage() {
  const { user, me, logoutNow } = useAuth();
  const navigate = useNavigate();
  const [logoutBusy, setLogoutBusy] = useState(false);

  async function onLogout() {
    setLogoutBusy(true);
    try {
      await logoutNow();
      navigate("/login", { replace: true });
    } finally {
      setLogoutBusy(false);
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <PageHeader title="Profil" />
      <Card>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
          <span className="brand-mark" aria-hidden>
            <UserRound size={18} />
          </span>
          <div>
            <strong style={{ fontSize: 16 }}>{user?.fullName}</strong>
            <p className="muted" style={{ margin: 0 }}>
              {ROLE_LABEL[user?.role ?? ""] ?? user?.role}
            </p>
          </div>
        </div>
        <div className="detail-lines">
          <div className="detail-line">
            <span className="k">Email</span>
            <span className="vv">{user?.email}</span>
          </div>
          {me?.tenant ? (
            <div className="detail-line">
              <span className="k">Lokasi</span>
              <span className="vv">{me.tenant.name}</span>
            </div>
          ) : null}
        </div>
      </Card>

      <ChangePasswordCard />

      <Button variant="danger" onClick={() => void onLogout()} loading={logoutBusy}>
        <LogOut size={16} /> Keluar
      </Button>
    </div>
  );
}
